import {CognitoIdentityProviderClient, InitiateAuthCommand, RespondToAuthChallengeCommand, SignUpCommand, InvalidPasswordException} from "@aws-sdk/client-cognito-identity-provider";
import {awsRegion, cognitoAppId} from "./constants.js";
import appEnvConfigService from "./appEnvConfigService.js";




var client = null;

export default {

	async initiateSignup(userName, password, email){
		let clientId = (await appEnvConfigService()).cognitoConfigId;
		if(client == null){
			let awsRegion = (await appEnvConfigService()).cognitoConfigRegion;
			client = new CognitoIdentityProviderClient({region: awsRegion});
		}

		let params = {
			Username: userName,
			Password: password,
			UserAttributes: [{Name: "email", Value: email}],
			ClientId: clientId
		}

		try{
			let authResult = await client.send(new SignUpCommand(params));

		}catch(e){
			if(e.name== "InvalidPasswordException"){
				console.log({e: e});
				throw e;
			}

		}
	},

	async attemptAuth(userName, passWord){

		let clientId = (await appEnvConfigService()).cognitoConfigId;
		if(client == null){
			let awsRegion = (await appEnvConfigService()).cognitoConfigRegion;
			client = new CognitoIdentityProviderClient({ region: awsRegion });
		}

		let params = {
			AuthFlow: "USER_PASSWORD_AUTH",
			AuthParameters: {
				USERNAME: userName,
				PASSWORD: passWord
			},
			ClientId: clientId

		}

		
		let authResult = await client.send(new InitiateAuthCommand(params));

		if(authResult.ChallengeName){
			return {success: false, challenge: authResult.ChallengeName, session: authResult.Session};
		}else{
			return {success: true, token: authResult.AuthenticationResult.AccessToken};
		}
	},


	async newPassword(userName, newPassword, session){

		let clientId = (await appEnvConfigService()).cognitoConfigId;

		if(client == null){
			let awsRegion = (await appEnvConfigService()).cognitoConfigRegion;
			client = new CognitoIdentityProviderClient({ region: awsRegion });
		}

		let params = {
			ChallengeName: "NEW_PASSWORD_REQUIRED",
			ClientId: clientId,
			Session: session,
			ChallengeResponses: {
				NEW_PASSWORD: newPassword,
				USERNAME: userName
			}
		}

		
		let authResult = await client.send(new RespondToAuthChallengeCommand(params));
		return {success: true, token: authResult.AuthenticationResult.AccessToken};
		
	}
}